module.exports = __webpack_public_path__ + "static/media/nextStepArrow.40694746.svg";